module.exports = __webpack_public_path__ + "img/uk-flag.b2bf0ff7.jpg";